import { challengeCards } from "@/pages/play/catalog";

export const MODEL_CHOICE_ELO = 2600;

export type ModelChoiceOption = {
  modelId: string;
  label: string;
  elo: number;
};

export const modelChoiceOptions: ModelChoiceOption[] = challengeCards.flatMap((card) => {
  if (card.variants?.length) {
    return card.variants.map((variant) => ({
      modelId: variant.modelId,
      label: `Crowd ${variant.label}`,
      elo: MODEL_CHOICE_ELO,
    }));
  }

  if (!card.modelId) {
    return [];
  }

  return [
    {
      modelId: card.modelId,
      label: card.kind === "group" ? `Crowd ${card.title}` : `${card.title} Model`,
      elo: MODEL_CHOICE_ELO,
    },
  ];
});

export const defaultModelChoiceOption =
  modelChoiceOptions.find((option) => option.modelId === "carlsen.best") ??
  modelChoiceOptions[0];
